import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MessageSquare } from 'lucide-react';
import { colors, detailStyles } from './detail.styles';
import { formatSignedAmount } from '../../../utils/adjustmentTotals';
/** "(10%)" percent detail after the dollar amount; empty for fixed/legacy rows. */
function percentDetail(event) {
    if (event.method !== 'percent' || event.value === undefined)
        return '';
    const n = Number(event.value);
    if (!Number.isFinite(n))
        return '';
    return ` (${String(parseFloat(n.toFixed(2)))}%)`;
}
export const AdjustmentEventSummary = ({ event, struck = false }) => {
    const isDiscount = event.adjustmentType === 'discount';
    const isRuleSourced = event.sourceKind === 'rule';
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: detailStyles.summaryRow, children: [_jsx("span", { style: detailStyles.summaryText, children: "Amount:" }), _jsxs("span", { "data-testid": "adjustment-amount", style: {
                            color: isDiscount ? colors.accent.red : colors.accent.green,
                            fontWeight: 600,
                            fontFamily: 'monospace',
                            textDecoration: struck ? 'line-through' : undefined,
                            opacity: struck ? 0.8 : 1,
                        }, children: [formatSignedAmount(event.adjustmentType, event.amount), percentDetail(event)] }), _jsx("span", { "data-testid": "adjustment-source-chip", style: isRuleSourced ? autoChipStyle : manualChipStyle, title: isRuleSourced ? `Applied automatically by the rule "${event.ruleName || 'unknown'}"` : 'Applied manually by a user', children: isRuleSourced ? `Auto${event.ruleName ? ` · ${event.ruleName}` : ''}` : 'Manual' })] }), event.reason && (_jsxs("div", { style: detailStyles.messageSection, children: [_jsxs("div", { style: detailStyles.sectionHeader, children: [_jsx(MessageSquare, { size: 16, style: { color: colors.accent.amber } }), _jsx("span", { children: "Reason" })] }), _jsx("div", { style: detailStyles.messageBox, children: event.reason })] }))] }));
};
const chipBase = {
    fontSize: 11,
    fontWeight: 600,
    padding: '1px 8px',
    borderRadius: 10,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 220,
};
const manualChipStyle = {
    ...chipBase,
    color: colors.accent.blue,
    backgroundColor: 'rgba(59, 130, 246, 0.15)',
};
const autoChipStyle = {
    ...chipBase,
    color: colors.text.secondary,
    backgroundColor: 'rgba(156, 163, 175, 0.15)',
};
export default AdjustmentEventSummary;
